import(/* webpackMode: "eager" */ "/app/app/(public)/(map)/(form)/password/forgot/page.tsx");
